<div id="ai-report-display" class="display bg-white border h-100">
  <div class="display-scroll">
    @if (facade.hoveredAsset(); as hovered) {
      <app-asset [asset]="hovered" mode="view" class="w-100 h-100"/>
    } @else if (facade.isLoading()) {
      <app-loading/>
    } @else {
      @if (facade.resultAssets().length > 0) {
        @let mainAssetId = facade.mainAssetId();
        @let hasMainAsset = !!mainAssetId && facade.resultAssets().includes(mainAssetId);
        <div class="position-relative w-100" style="min-height: 100%;">
          <!-- Background images -->
          @for (id of facade.resultAssets(); track id) {
            @if (id | assetMeta | async; as asset) {
              @if (hasMainAsset ? asset.id === mainAssetId :
                   (!['svg-defs', 'family-tree', 'person-events', 'layout', 'url'].includes(asset.type) &&
                   asset.id !== visjsBackgroundId())) {
                <app-asset [asset]="asset" mode="view" class="w-100 h-100"/>
              }
            }
          }
        </div>
      } @else {
        <div class="d-flex align-items-center justify-content-center h-100">
                  <span class="text-muted small">
                      {{ "aiReport.lbl_report_display" | translate }}
                  </span>
        </div>
      }
    }

    <div class="px-3 pb-3">
      <button id="ai-assets-toggle" class="assets-toggle mt-2" (click)="toggleAllAssets()">
        <i class="bi" [class.bi-chevron-up]="showAllAssets()" [class.bi-chevron-down]="!showAllAssets()"></i>
        {{ showAllAssets() ? ('aiReport.assets_toggle_hide' | translate) : ('aiReport.assets_toggle_show' | translate) }}
      </button>

      @if (showAllAssets()) {
        <div class="mt-2">
          <app-asset-list/>
        </div>
      }
    </div>
  </div>

  <button
    type="button"
    id="ai-export-fab"
    class="export-fab"
    data-testid="export-fab"
    [disabled]="isPublishDisabled() || isPublishing()"
    [title]="fabTitle()"
    (click)="publishReport()"
  >
    <img src="/assets/images/icons/download.svg" alt="Publish-Button" />
  </button>

  @if (publishOutcome()) {
    <app-toast
      id="ai-export-toast"
      class="export-toast"
      [message]="toastMessage()"
      [actionLabel]="toastActionLabel()"
      (action)="openReportManager()"
      (dismissed)="dismissToast()"
    />
  }
</div>
